import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ktag/styleguide/dist/react';
import { useLayers } from '@agissc/ktag-map';
import useAppState from '../../AppStore';
import InfoBox from '../../components/infoBox/InfoBox';
import useToggleTopicLayer from '../hooks/useToggleTopicLayer';

const SWISSIMAGE_LAYER_ID = 'ch.swisstopo.swissimage::wms.geo.admin.ch';

interface SearchInfoBoxNotInAGProps {
  onClose: () => void;
}

const SearchInfoBoxNotInAG = ({ onClose }: SearchInfoBoxNotInAGProps) => {
  const { t } = useTranslation('agisviewer');
  const { addTopicLayer } = useToggleTopicLayer();
  const moveTopicLayer = useAppState((state) => state.moveTopicLayer);
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);
  const { data: layerData = {}, isLoading } = useLayers();

  const pendingMove = useRef(false);

  useEffect(() => {
    if (!pendingMove.current) return;
    if (!selectedTopicLayers.includes(SWISSIMAGE_LAYER_ID)) return;

    moveTopicLayer(SWISSIMAGE_LAYER_ID, selectedTopicLayers.length - 1);
    pendingMove.current = false;
    onClose();
  }, [selectedTopicLayers, moveTopicLayer, onClose]);

  if (isLoading) return null;

  const isSwissimageSelected = selectedTopicLayers.includes(SWISSIMAGE_LAYER_ID);

  const handleAddSwissimage = () => {
    if (isSwissimageSelected) return;

    const topicLayer = Object.values(layerData).find(
      (layer) => layer.id === SWISSIMAGE_LAYER_ID,
    );

    if (!topicLayer) return;

    pendingMove.current = true;
    addTopicLayer(topicLayer);
  };

  return (
    <InfoBox heading={t('info_box_title')} onClose={onClose}>
      <p>{t('seach_notify_no_ktag')}</p>
      {!isSwissimageSelected && (
        <>
          <p>{t('seach_notify_no_ktag_add_swissimage')}</p>
          <Button onClick={handleAddSwissimage} additionalClassNames="button__max-width">
            OK
          </Button>
        </>
      )}
    </InfoBox>
  );
};

export default SearchInfoBoxNotInAG;
